// extracted by mini-css-extract-plugin
export default {"journey":"styles_journey__XDZZW","logos":"styles_logos__Ym16w"};